<script lang="ts" setup>
import type { TripMonitorTripStopWithId } from "@/api/trips/dto/trip-monitor";
import RouteStopIcon from "@/components/routeStop/RouteStopIcon.vue";
import { computed } from "vue";
import OmniTooltip from "@/components/OmniTooltip.vue";
import { useI18n } from "vue-i18n";
import { OrderStopTypeMap } from "@/data/order";

const props = defineProps<{
  tripStops: TripMonitorTripStopWithId[];
  tripStop: TripMonitorTripStopWithId;
  showDivider: boolean;
}>();

const { t } = useI18n();

const index = computed(() => {
  return props.tripStops.findIndex((item) => item.id === props.tripStop.id);
});

const isDeleted = computed(() => {
  return props.tripStop.isDeleted;
});
</script>

<template>
  <omni-tooltip :disabled="!isDeleted">
    <template #activator>
      <div class="trip-stop d-flex align-center col-gap-2">
        <div
          :class="{
            'trip-stop__index--deleted': isDeleted,
          }"
          class="trip-stop__index"
        >
          {{ index + 1 }}
        </div>
        <route-stop-icon :is-deleted="isDeleted" :is-reload="tripStop.isReload" :type="tripStop.type" class="ml-1" />

        <span
          :class="{
            'text-grey-lighten-1': isDeleted,
          }"
          data-qa="trip-stop-address"
          >{{ tripStop.address }}</span
        >

        <div v-if="showDivider" class="trip-stop__divider"></div>
      </div>
    </template>
    {{
      t("trip.stop-has-been-deleted", {
        type: OrderStopTypeMap[tripStop.type],
        index: index + 1,
      })
    }}
  </omni-tooltip>
</template>

<style lang="scss" scoped>
@import "@/assets/style/color";

.trip-stop {
  &__index {
    min-width: 20px;
    min-height: 20px;
    background-color: $grey-lighter-contrast;
    color: $white;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    font-size: 12px;

    &--deleted {
      background-color: $grey-lighten-2;
    }
  }

  &__divider {
    width: 20px;
    height: 2px;
    background-color: $grey-lighten-2;
  }
}
</style>
